import React from 'react'

import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import * as Styles from './styles'

import Toast from '../Toast'

export default function ClassView({ onClick, view }) {
    const { isArtefactMode, isQuizMode } = useVideoContext()

    return (
        <Styles.Wrapper onClick={onClick} isQuizMode={isQuizMode}>
            <Styles.ArtefactContainer
                isArtefactMode={isArtefactMode}
                isQuizMode={isQuizMode}
            >
                {React.cloneElement(view, { isMobileView: true })}
            </Styles.ArtefactContainer>
            <Toast />
        </Styles.Wrapper>
    )
}
